import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from './../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SearchService {

    constructor(private http: HttpClient) { }

    /**
     * The site's search index, every type in one ranked list (title, theater, user, cast, list, watch-now-service),
     * as the header of cinemapp.be searches it: the topbar's search. A title's `title` and `poster` are the Dutch ones
     * (the API's default is English). The admin's searches never reach the query log (the API's isInternalClient).
     */
    global(query: string): Observable<any[]> {
        const params = { query, returnAsArray: 'true' };
        return this.http.get<any[]>(`${environment.api}search`, { params, headers: { localisation: 'be_nl' } });
    }

    /**
     * The search query log: one row per query + language, with how often it was searched, how often it answered
     * nothing and how often somebody clicked a result of it. `noResults=true` narrows it to what the catalogue
     * is missing, `unclicked=true` to what it answers badly.
     */
    getQueries(params): Observable<any> {
        return this.http.get<any>(`${environment.api}search/admin/queries`, { params });
    }

    /**
     * One member's search history (the user detail's Searches tab): the results they opened from a search on the
     * site or in the apps, newest first, with what they typed, the place in the list, the search box and the
     * platform. `item` is the clicked document's name and picture, null when it no longer exists.
     */
    getUserSearches(userId: string, params: { page?: number; size?: number } = {}): Observable<any> {
        return this.http.get<any>(`${environment.api}search/admin/users/${userId}`, { params: params as any });
    }

    /**
     * Recounts the search clicks and the theater save counts into the `boost` of every document they belong to
     * and pushes what changed back into the index. It runs by itself every night at 03:45; this is the "now".
     */
    recalculateBoosts(): Observable<any> {
        return this.http.post<any>(`${environment.api}search/admin/recalculate-boosts`, {});
    }

}
